import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { LookUpResponse } from '../../responses/integration-relation-config/look-up.response';

@Injectable({
  providedIn: 'root'
})
export class LookupIntegrationConfigService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  List(): Observable<LookUpResponse> {
    let uri = `LookUp`
    return this.httpClient.get<LookUpResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiIntegrationRelationConfig) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
